/**
 * Created by inonstelman on 12/28/14.
 */

(function () {
    "use strict";

    // @ngInject
    function APIServiceCtor($http, RepositoryService, $q, Gon, PubSubService, AppConfigService, _, RollingWindowThrottleService, TrackJS) {
        this.$http = $http;
        this.RepositoryService = RepositoryService;
        this.$q = $q;
        this.TrackJS = TrackJS;
        this.Gon = Gon;
        this._ = _;

        this.AppConfigService = AppConfigService;
        this.RollingWindowThrottleService = RollingWindowThrottleService;

        PubSubService.ventMyBitchUp(this);
    }

    Services.APIService = Class(function () {

        return {

            constructor: APIServiceCtor,

            _performRequest: function _performRequest(method, url, data, headers) {

                var reqHeaders = {};

                if (headers) {
                    angular.extend(reqHeaders, headers);
                }

                if (!this._.isEmpty(this.Gon.api_urls_prefix)) {
                    url = this.Gon.api_urls_prefix + url;
                }

                var req;
                if (method === 'GET' || method === 'DELETE') {

                    // Add cache buster to all AJAX GET requests because some fucked-up browsers (Safari) cache them (????)
                    // http://stackoverflow.com/questions/9948545/how-to-disable-ajax-caching-in-safari-browser
                    //
                    // Because of the angular templates cache we cannot use an HTTP Interceptor
                    
                    // 15/05/16 - Doron: reverted this change as it needs to be fixed by proper headers,
                    // and not by query params. However, I cannot reproduce this bug so for now - no new
                    // headers are set.
                    // if (method === 'GET') {
                    //     if (!angular.isObject(data)) {
                    //         data = {};
                    //     }
                    //     data['nocache'] = +(new Date());
                    // }

                    if (method === 'GET') {
                        if (angular.isObject(data)) {
                            // modify keys that are of type array to syntax that allows sending an array over url params
                            var deleteKeys = [];

                            Object.keys(data).forEach(function(key) {
                                if(Array.isArray(data[key])) {
                                    data[key + "[]"] = data[key];
                                    deleteKeys.push(key);
                                }
                            });

                            deleteKeys.forEach(function(key) {
                                delete data[key];
                            });
                        }
                    }

                    req = {
                        method: method,
                        url: url,
                        headers: reqHeaders,
                        params: data
                    };
                } else {
                    req = {
                        method: method,
                        url: url,
                        headers: reqHeaders,
                        data: data
                    };
                }

                var defer = this.$q.defer();

                this.$http(req)
                    .success(function (data, status, headers, config, statusText) {
                        defer.resolve({
                            data: data,
                            status: status,
                            headers: headers,
                            config: config,
                            statusText: statusText
                        });

                        this.trigger('success', data, status, headers, config, statusText);

                    }.bind(this))
                    .error(function (data, status, headers, config, statusText) {

                        var resp = {
                            data: data,
                            status: status,
                            headers: headers,
                            config: config,
                            statusText: statusText,
                            stopEvents: false
                        };

                        this.trigger('error*', data, status, headers, config, statusText);
                        if (data && data.error_type) {
                            this.trigger(data.error_type, data, status, headers, config, statusText);
                        }

                        defer.reject(resp);

                    }.bind(this));

                var throttleRes = this.RollingWindowThrottleService.addEntryAndCheckIfLimitHit(url, this.RollingWindowThrottleService.generateOptions(40, 60000));

                if(throttleRes){
                    //a request was performed more than 40 times in a minute - sending to trackjs for analysis
                    this.TrackJS && this.TrackJS.track("Request limit was hit. url: " + url + ", method(last): " + method + ", invocationCount: " + throttleRes.count + ", rollingWindowMS: " + throttleRes.options.windowTimeMS);
                }

                return defer.promise;

            },

            fetch: function fetch(url, data, headers) {
                return this._performRequest('GET', url, data, headers);
            },

            create: function create(url, data, headers) {
                return this._performRequest('POST', url, data, headers);
            },

            update: function update(url, data, headers) {
                return this._performRequest('PUT', url, data, headers);
            },

            destroy: function destroy(url, data, headers) {
                return this._performRequest('DELETE', url, data, headers);
            }
        };
    });

}());
